import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useOrg } from './useOrg';
import { useUserOrganizations } from './useOrganizations';

export default function OrgGuard() {
  const { selectedOrg, isInitializing } = useOrg();
  const { isLoading } = useUserOrganizations();
  const location = useLocation();

  // Wait for both org context initialization and user organizations to load
  if (isInitializing || isLoading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        Loading organization data...
      </div>
    );
  }

  // If no org is selected, redirect to selection page
  if (!selectedOrg) {
    // For users with no organizations or those who need to select
    return (
      <Navigate to='/select-org' replace state={{ from: location.pathname }} />
    );
  }

  return <Outlet />;
}
